import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKOeln() {
  return (
    <CityPageTemplate
      city="Köln"
      slug="koeln"
      intro="Köln wächst – und mit ihm die Ansprüche an eine smarte, zukunftssichere Finanzplanung."
      description="Unabhängige & digitale Finanzberatung für Köln: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
